import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient, ENDPOINTS } from "../../../services/common";

//Get Seller Campaigns Count

export const sellerCampaignsCount = createAsyncThunk(
  "sellerCampaignsCount",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.GET_CAMPAIGNS_COUNT);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching campaigns count request."
      );
    }
  }
);

// Get Seller Campaigns
export const getSellerCampaigns = createAsyncThunk(
  "campaigns-seller",
  async (value, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.CAMPAIGNS_SELLER + `?tab_status=${value}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request."
      );
    }
  }
);

//View Single Campaign Details

export const viewCampaignDetails = createAsyncThunk(
  "view-campaign",
  async (campaignId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.VIEW_CAMPAIGN_DETAILS + `/${campaignId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details"
      );
    }
  }
);

// Get Offer Details

export const getOfferDetails = createAsyncThunk(
  "offer-details",
  async (campaignId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.OFFER_DETAILS + `/${campaignId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details"
      );
    }
  }
);

//get Offer Comments
export const getOfferComments = createAsyncThunk(
  "offer-comments",
  async (offerId, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.OFFER_COMMENTS + `/${offerId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while viewing campaign details"
      );
    }
  }
);

// get owner products
export const getOwnerProducts = createAsyncThunk(
  "approved-owner-products",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.OWNER_PRODUCTS,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occured while viewing campaign details"
      );
    }
  }
);

// upload CSV
export const uploadCSV = createAsyncThunk(
  "upload-csv",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.UPLOAD_CSV,
        payload,
        {}
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occured while viewing campaign details"
      );
    }
  }
);

//Product Visibility

export const productVisibility = createAsyncThunk(
  "product-visibility",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { productId } = payload;
      const payloadWithoutProductId = { ...payload };
      delete payloadWithoutProductId.productId;
      const response = await axiosClient.put(
        `${ENDPOINTS.PRODUCT_VISIBILITY}/${productId}`,
        payloadWithoutProductId
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occured while viewing campaign details"
      );
    }
  }
);

// Featured Campaigns for products
export const featuredCampaignProducts = createAsyncThunk(
  "featured-products",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.FEATURED_CAMPAIGNS}/${payload}`,
        {}
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occured while viewing featured campaigns"
      );
    }
  }
);

// Campaign Payments
export const campaignPayments = createAsyncThunk(
  "campaign-payments",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.CAMPAIGN_PAYMENTS,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occured while fetching campaign payments"
      );
    }
  }
);

export const getSellerCampaignsList = createAsyncThunk(
  "campaigns-seller-list",
  async (payload = {}, { rejectWithValue, getState }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.CAMPAIGNS_SELLER,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a productslist request."
      );
    }
  }
);

//seller product types api
export const getProductTypeList = createAsyncThunk(
  "product-type-list",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.PRODUCT_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while getting a product types."
      );
    }
  }
);

//seller product channnels api
export const getChannelsFromProductType = createAsyncThunk(
  "product-channels-list",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PRODUCT_CHANNELS,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while getting a product types."
      );
    }
  }
);

// seller save product details
export const saveProductDetails = createAsyncThunk(
  "save-product-details",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.SAVE_PRODUCT_DETAILS,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while getting a product types."
      );
    }
  }
);

// seller clone product details
export const saveClonedProductDetails = createAsyncThunk(
  "save-cloned-product-details",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.SAVE_CLONED_PRODUCT_DETAILS,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while getting a product types."
      );
    }
  }
);

// get rfp list to seller
export const getRfpRequests = createAsyncThunk(
  "get-rfp-requests",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.RFP_REQUESTS);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// product details to seller
export const getProductDetails = createAsyncThunk(
  "get-rfp-requests",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.GET_PRODUCT_DETAILS}/${payload}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// get products per user
export const getProductsPerUser = createAsyncThunk(
  "get-products-per-user",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.GET_PRODUCTS_PER_USER}`
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// deleting image from billboard to seller
export const deleteImageFromBillBoard = createAsyncThunk(
  "delete-billboard-image",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.delete(
        ENDPOINTS.DELETE_IMAGE_FROM_BILLBOARD,
        {
          data: payload,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// get all sellers list api
export const getAllSellers = createAsyncThunk(
  "get-all-sellers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(ENDPOINTS.GET_ALL_SELLERS, {
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// get all bulk products list api
export const getAllBulkProducts = createAsyncThunk(
  "get-all-bulk-products",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        ENDPOINTS.GET_ALL_BULK_UPLOADED_PRODUCTS,
        {
          data: payload,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// save transfer products api
export const postTransferProducts = createAsyncThunk(
  "post-transfer-products",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.POST_TRANSFER_PRODUCTS,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

// search product by id and name api
export const searchProductsByIdAndName = createAsyncThunk(
  "search-products",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.SEARCH_PRODUCTS}/${payload}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during search products."
      );
    }
  }
);

// Seller dashboard campaign activities
export const getSellerDashboardActivities = createAsyncThunk(
  "seller-dashboard-activities",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.SELLER_CAMPAIGN_ACTIVITIES}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching campaign activities."
      );
    }
  }
);

export const getSellerPaymentsInDashboard = createAsyncThunk(
  "seller-payments-in-dashboard",
  async (payload, { rejectWithValue }) => {
    try {
      const url =
        payload.type == "monthly"
          ? `${ENDPOINTS.SELLER_PAYMENTS_MONTHLY_EARLY}?year=${payload?.selectedYear}&month=${payload?.selectedMonth}`
          : `${ENDPOINTS.SELLER_PAYMENTS_MONTHLY_EARLY}?year=${payload?.selectedYear}`;
      const response = await axiosClient.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occured while fetching payments"
      );
    }
  }
);
//GET seller terms requests
export const getSellerTermsRequests = createAsyncThunk(
  "seller-terms-requests",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.SELLER_TERMS_REQUESTS}tab_status=${payload}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching campaign activities."
      );
    }
  }
);

//update seller terms requests
export const updateSellerTermsRequests = createAsyncThunk(
  "seller-terms-requests-updation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        `${ENDPOINTS.SELLER_TERMS_REQUESTS_UPDATION}`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching campaign activities."
      );
    }
  }
);

export const initiateSign = createAsyncThunk(
  "initiate-sign",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.INITIATE_SIGN,
        payload
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while initiating the signature"
      );
    }
  }
);
